import { compose } from '../../reactApolloCompat';
import withTheme from '@mui/styles/withTheme';
import withStyles from '@mui/styles/withStyles';
import React, { Component } from 'react';
import * as Icons from '../../components/IconIndex';
import * as MaterialIcons from '@mui/icons-material';
import Grid from '../../components/layout/Grid';
import TextField from '../../components/form/TextField';

class IconsPreview extends Component {
    state = {
        lookupIcon: ''
    };

    render() {
        const { lookupIcon } = this.state;
        return (
            <Grid container>
                {Object.keys(Icons).map(key => {
                    const Icon = Icons[key];
                    return (
                        <Grid item xs={6} md={3} key={key}>
                            <Icon value={66} /> &nbsp;&lt;{key}/&gt;
                        </Grid>
                    );
                })}

                <Grid item xs={12}>
                    <hr />
                    <h2>MaterialUI Icons</h2>
                    <TextField
                        label="Search for an icon"
                        placeholder="Type at least three letters to search for..."
                        value={lookupIcon}
                        onChange={(evt) => this.setState({ lookupIcon: evt.target.value })}
                    />
                </Grid>
                {Object.keys(MaterialIcons)
                    .filter(
                        (str) =>
                            !!lookupIcon &&
                            lookupIcon.length > 2 &&
                            str.toLowerCase().includes(lookupIcon.toLowerCase()) &&
                            (!str.endsWith('Sharp')/* && !str.endsWith('Outlined')*/ && !str.endsWith('TwoTone') && !str.endsWith('Rounded'))
                    )
                    .map((key) => {
                        const Icon = MaterialIcons[key];
                        return (
                            <Grid item xs={3} key={key}>
                                <Icon />&nbsp;{key}
                            </Grid>
                        );
                    })}
            </Grid>
        );
    }
}

const styles = () => {
};
export default compose(withTheme, withStyles(styles))(IconsPreview);
